export default __webpack_public_path__ + "static/media/before-footer-img4.c0b1e286.png";